import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventOwnGoal extends DomainEvent<MatchEvent> {}
